<template>
  <div id="ops-dashboard" class="custom-font">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Servicios Operativos</li>
      </ol>
    </nav>
    <div class="container-fluid">

      <vs-tabs>
        <!-- TAB METRICAS DE ORIGINACIÓN -->
        <vs-tab label="Metabase">
          <metabase-dashboard
              :dashboard-id="56"
              params="theme=transparent&bordered=false&titled=false" />
        </vs-tab>
        <vs-tab label="Métricas de originación">
          <vx-card no-shadow>
            <project-stats-dashboard></project-stats-dashboard>
          </vx-card>
        </vs-tab>
        <!-- TAB METRICAS DE ORIGINACIÓN -->
        <!-- TAB DASHBOARD -->
        <vs-tab label="Dashboard" icon="dashboard">
          <div class="row">
            <div class="col-md-12">
              <md-card>
                <md-card-header>
                  <md-card-header-text>
                    <div class="md-title">Dashboard Operativo</div>
                    <vs-alert icon-pack="feather" icon="icon-info" color="warning" active="true"
                              style="height: auto !important;">
                      La información aquí presentada corresponde a los últimos 90 días de operaciones.
                    </vs-alert>
                  </md-card-header-text>
                </md-card-header>
                <md-card-content>
                  <div class="row">
                    <!-- SECCIÓN TABLAS  -->
                    <div class="col-8">
                      <md-card style="padding:1rem;">
                        <!-- ORGINICACIÓN  -->
                        <vs-table :data="originData" stripe noDataText="No hay datos disponibles">
                          <template slot="header">
                            <h4 class="custom-font">Originación</h4>
                          </template>
                          <template slot="thead">
                            <vs-th>Proceso</vs-th>
                            <vs-th>
                              <div class="triage triage-green"></div>
                            </vs-th>
                            <vs-th>
                              <div class="triage triage-yellow"></div>
                            </vs-th>
                            <vs-th>
                              <div class="triage triage-red"></div>
                            </vs-th>
                            <vs-th>Total</vs-th>
                            <vs-th>TPA (días)</vs-th>
                            <vs-th>PC (%)</vs-th>
                          </template>
                          <template slot-scope="{data}">
                            <template v-for="(tr, indextr) in data">
                              <vs-tr :key="indextr">
                                <vs-td :data="data[indextr].name">
                                  <vs-button type="line" @click="handleSelected(tr.url)">{{ tr.name }}</vs-button>
                                </vs-td>
                                <vs-td :data="data[indextr].green">
                                  {{ tr.green }}
                                </vs-td>
                                <vs-td :data="data[indextr].yellow">
                                  {{ tr.yellow }}
                                </vs-td>
                                <vs-td :data="data[indextr].red">
                                  {{ tr.red }}
                                </vs-td>
                                <vs-td :data="data[indextr].total">
                                  {{ tr.total }}
                                </vs-td>
                                <vs-td :data="data[indextr].tpa">
                                  {{ tr.tpa }}
                                </vs-td>
                                <vs-td :data="data[indextr].pc">
                                  {{ tr.pc }}
                                </vs-td>
                              </vs-tr>

                            </template>
                          </template>
                        </vs-table>
                        <!-- ORGINICACIÓN  -->

                        <hr>
                        <!-- SEGUIMIENTO DE PROYECTO  -->
                        <vs-table :data="projectsData" stripe noDataText="No hay datos disponibles">
                          <template slot="header">
                            <h4 class="custom-font">Fondeo y seguimiento de proyectos</h4>
                          </template>
                          <template slot="thead">
                            <vs-th>Proceso</vs-th>
                            <vs-th>
                              <div class="triage triage-green"></div>
                            </vs-th>
                            <vs-th>
                              <div class="triage triage-yellow"></div>
                            </vs-th>
                            <vs-th>
                              <div class="triage triage-red"></div>
                            </vs-th>
                            <vs-th>Total</vs-th>
                            <vs-th>TPA (días)</vs-th>
                            <vs-th>PC (%)</vs-th>
                          </template>
                          <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                              <vs-td :data="data[indextr].name">
                                <vs-button type="line" @click="handleSelected(tr.url)">{{ tr.name }}</vs-button>
                              </vs-td>
                              <vs-td :data="data[indextr].green">
                                {{ tr.green }}
                              </vs-td>
                              <vs-td :data="data[indextr].yellow">
                                {{ tr.yellow }}
                              </vs-td>
                              <vs-td :data="data[indextr].red">
                                {{ tr.red }}
                              </vs-td>
                              <vs-td :data="data[indextr].total">
                                {{ tr.total }}
                              </vs-td>
                              <vs-td :data="data[indextr].tpa">
                                {{ tr.tpa }}
                              </vs-td>
                              <vs-td :data="data[indextr].pc">
                                {{ tr.pc }}
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                        <!-- SEGUIMIENTO DE PROYECTO  -->

                        <hr>
                        <!-- EJECUTIVO DE CUENTA -->
                        <vs-table :data="executiveData" stripe noDataText="No hay datos disponibles">
                          <template slot="header">
                            <h4 class="custom-font">Ejecutivo de Cuenta</h4>
                          </template>
                          <template slot="thead">
                            <vs-th>Proceso</vs-th>
                            <vs-th>
                              <div class="triage triage-green"></div>
                            </vs-th>
                            <vs-th>
                              <div class="triage triage-yellow"></div>
                            </vs-th>
                            <vs-th>
                              <div class="triage triage-red"></div>
                            </vs-th>
                            <vs-th>Total</vs-th>
                            <vs-th>TPA (días)</vs-th>
                            <vs-th>PC (%)</vs-th>
                          </template>
                          <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                              <vs-td :data="data[indextr].name">
                                <vs-button type="line" @click="handleSelected(tr.url)">{{ tr.name }}</vs-button>
                              </vs-td>
                              <vs-td :data="data[indextr].green">
                                {{ tr.green }}
                              </vs-td>
                              <vs-td :data="data[indextr].yellow">
                                {{ tr.yellow }}
                              </vs-td>
                              <vs-td :data="data[indextr].red">
                                {{ tr.red }}
                              </vs-td>
                              <vs-td :data="data[indextr].total">
                                {{ tr.total }}
                              </vs-td>
                              <vs-td :data="data[indextr].tpa">
                                {{ tr.tpa }}
                              </vs-td>
                              <vs-td :data="data[indextr].pc">
                                {{ tr.pc }}
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                        <!-- EJECUTIVO DE CUENTA -->
                        <hr>
                        <!-- COMUNICACIÓN  -->
                        <vs-table :data="comunicationData" stripe noDataText="No hay datos disponibles">
                          <template slot="header">
                            <h4 class="custom-font">Comunicación</h4>
                          </template>
                          <template slot="thead">
                            <vs-th>Proceso</vs-th>
                            <vs-th>
                              <div class="triage triage-green"></div>
                            </vs-th>
                            <vs-th>
                              <div class="triage triage-yellow"></div>
                            </vs-th>
                            <vs-th>
                              <div class="triage triage-red"></div>
                            </vs-th>
                            <vs-th>Total</vs-th>
                            <vs-th>TPA (días)</vs-th>
                            <vs-th>PC (%)</vs-th>
                          </template>
                          <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                              <vs-td :data="data[indextr].name">
                                <vs-button type="line" @click="handleSelected(tr.url)">{{ tr.name }}</vs-button>
                              </vs-td>
                              <vs-td :data="data[indextr].green">
                                {{ tr.green }}
                              </vs-td>
                              <vs-td :data="data[indextr].yellow">
                                {{ tr.yellow }}
                              </vs-td>
                              <vs-td :data="data[indextr].red">
                                {{ tr.red }}
                              </vs-td>
                              <vs-td :data="data[indextr].total">
                                {{ tr.total }}
                              </vs-td>
                              <vs-td :data="data[indextr].tpa">
                                {{ tr.tpa }}
                              </vs-td>
                              <vs-td :data="data[indextr].pc">
                                {{ tr.pc }}
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                        <!-- COMUNICACIÓN -->
                      </md-card>
                    </div>
                    <!-- SECCIÓN TABLAS  -->

                    <!-- SECCIÓN RESUMEN  -->
                    <div class="col-4">
                      <!-- SECCIÓN FILTRO  -->
                      <md-card class="kpis-card">
                        <div>
                          <h4 class="custom-font"><strong>Días Operativos</strong></h4>
                          <div class="row">
                            <div class="col-9">
                              <vs-input class="inputx" placeholder="Días de operación" v-model.number="days"/>
                            </div>
                            <div class="col-3">
                              <vs-button @click="getDashboardInfo()" radius color="success" type="filled"
                                         icon="refresh"></vs-button>
                            </div>
                          </div>
                        </div>
                      </md-card>
                      <!-- SECCIÓN FILTRO  -->
                      <br>
                      <!-- RESUMEN GENERAL -->
                      <md-card class="kpis-card">
                        <div>
                          <h4 class="custom-font"><strong>Resumen General</strong></h4>
                          <div class="row summary-row">
                            <div class="col-sm-12 col-md-6 summary-row-div-col-sm-12">
                              <div class="summary bg-success text-white">
                                <div class="row">
                                  <div class="col-6 align-icons-c ">
                                    <em class="material-icons">check_circle</em>
                                    <h5 class="custom-font">Total</h5>
                                  </div>
                                  <div class="col-6">
                                    <h1 class="custom-font">{{ totals.totalGreen }}</h1>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-12 col-md-6 summary-row-div-col-sm-12">
                              <div class="summary bg-warning text-white">
                                <div class="row">
                                  <div class="col-6 align-icons-c ">
                                    <em class="material-icons">error</em>
                                    <h5 class="custom-font">Total</h5>
                                  </div>
                                  <div class="col-6">
                                    <h1 class="custom-font">{{ totals.totalYellow }}</h1>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-12 col-md-6 summary-row-div-col-sm-12">
                              <div class="summary bg-danger text-white">
                                <div class="row">
                                  <div class="col-6 align-icons-c ">
                                    <em class="material-icons">warning</em>
                                    <h5 class="custom-font">Total</h5>
                                  </div>
                                  <div class="col-6">
                                    <h1 class="custom-font">{{ totals.totalRed }}</h1>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-12 col-md-6 summary-row-div-col-sm-12">
                              <div class="summary text-white">
                                <div class="row">
                                  <div class="col-6 align-icons-c ">
                                    <em class="material-icons">show_chart</em>
                                    <h5 class="custom-font">Total</h5>
                                  </div>
                                  <div class="col-6">
                                    <h1 class="custom-font">{{ totals.total }}</h1>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </md-card>
                      <!-- RESUMEN GENERAL -->
                      <br>
                      <!-- RESUMEN POR GRUPO -->
                      <md-card class="kpis-card">
                        <div>
                          <h4 class="custom-font"><strong>Resumen por Servicio</strong></h4>
                          <div class="row summary-row">
                            <div class="col-sm-12 summary-item">
                              <div class="row">
                                <div class="col-sm-12 col-md-6">
                                  <h6 class="custom-font">Originación</h6>
                                </div>
                                <div class="col-sm-12 col-md-6 summary-triage-parent">
                                  <span class="summary-triage bg-success"
                                        style="left: 0rem;">{{ this.totals.groups[0].tGroupGreen }}</span>
                                  <span class="summary-triage bg-warning"
                                        style="left: 2.3rem;">{{ this.totals.groups[0].tGroupYellow }}</span>
                                  <span class="summary-triage bg-danger"
                                        style="left: 4.6rem;">{{ this.totals.groups[0].tGroupRed }}</span>
                                  <span class="summary-triage"
                                        style="left: 6.9rem;">{{ this.totals.groups[0].tGroup }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-12 summary-item">
                              <div class="row">
                                <div class="col-sm-12  col-md-6">
                                  <h6 class="custom-font">Seguimiento de Proyectos</h6>
                                </div>
                                <div class="col-sm-12  col-md-6 summary-triage-parent">
                                  <span class="summary-triage bg-success"
                                        style="left: 0rem;">{{ this.totals.groups[1].tGroupGreen }}</span>
                                  <span class="summary-triage bg-warning"
                                        style="left: 2.3rem;">{{ this.totals.groups[1].tGroupYellow }}</span>
                                  <span class="summary-triage bg-danger"
                                        style="left: 4.6rem;">{{ this.totals.groups[1].tGroupRed }}</span>
                                  <span class="summary-triage"
                                        style="left: 6.9rem;">{{ this.totals.groups[1].tGroup }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-12 summary-item">
                              <div class="row">
                                <div class="col-sm-12  col-md-6">
                                  <h6 class="custom-font">Ejecutivo de Cuenta</h6>
                                </div>
                                <div class="col-sm-12  col-md-6 summary-triage-parent">
                                  <span class="summary-triage bg-success"
                                        style="left: 0rem;">{{ this.totals.groups[2].tGroupGreen }}</span>
                                  <span class="summary-triage bg-warning"
                                        style="left: 2.3rem;">{{ this.totals.groups[2].tGroupYellow }}</span>
                                  <span class="summary-triage bg-danger"
                                        style="left: 4.6rem;">{{ this.totals.groups[2].tGroupRed }}</span>
                                  <span class="summary-triage"
                                        style="left: 6.9rem;">{{ this.totals.groups[2].tGroup }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-12 summary-item">
                              <div class="row">
                                <div class="col-sm-12  col-md-6">
                                  <h6 class="custom-font">Comunicación</h6>
                                </div>
                                <div class="col-sm-12  col-md-6 summary-triage-parent">
                                  <span class="summary-triage bg-success"
                                        style="left: 0rem;">{{ this.totals.groups[3].tGroupGreen }}</span>
                                  <span class="summary-triage bg-warning"
                                        style="left: 2.3rem;">{{ this.totals.groups[3].tGroupYellow }}</span>
                                  <span class="summary-triage bg-danger"
                                        style="left: 4.6rem;">{{ this.totals.groups[3].tGroupRed }}</span>
                                  <span class="summary-triage"
                                        style="left: 6.9rem;">{{ this.totals.groups[3].tGroup }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </md-card>
                      <!-- RESUMEN POR GRUPO -->
                    </div>
                    <!-- SECCIÓN RESUMEN  -->
                  </div>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </vs-tab>
        <!-- TAB DASHBOARD -->
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import ProjectStatsDashboard from './suppliers/ProjectStatsDashboard.vue';

const months = [
  {value: 1, text: "Enero"}
  , {value: 2, text: "Febrero"}
  , {value: 3, text: "Marzo"}
  , {value: 4, text: "Abril"}
  , {value: 5, text: "Mayo"}
  , {value: 6, text: "Junio"}
  , {value: 7, text: "Julio"}
  , {value: 8, text: "Agosto"}
  , {value: 9, text: "Septiembre"}
  , {value: 10, text: "Octubre"}
  , {value: 11, text: "Noviembre"}
  , {value: 12, text: "Diciembre"}
];
import LineChart from '@components/LineChart.vue'
import MetabaseDashboard from "@components/metabase/MetabaseDashboard.vue";

export default {
  components: {
    MetabaseDashboard,
    LineChart,
    ProjectStatsDashboard
  },
  data() {
    return {
      metabase: {
        iframeUrl: null
      },
      // graphs
      time: true
      , month: 0
      , months: months
      , year: 0
      , years: []

      , chartSuppliersVerification: {
        data: null,
        options: null
      }
      , chartTechVerification: {
        data: null,
        options: null
      }
      , chartCreditVerification: {
        data: null,
        options: null
      }
      , chartApproved: {
        data: null,
        options: null
      }
      , chartToPost: {
        data: null,
        options: null
      }
      , chartContracts: {
        data: null,
        options: null
      }
      , chartFirstPayment: {
        data: null,
        options: null
      }
      , chartEvidence: {
        data: null,
        options: null
      }
      , chartSecondPayment: {
        data: null,
        options: null
      }
      , chartBAInvestors: {
        data: null,
        options: null
      }
      , chartIdentity: {
        data: null,
        options: null
      }
      , chartFeedBack: {
        data: null,
        options: null
      }

      , chartSuppliersVerificationTPA: {
        data: null,
        options: null
      }
      , chartTechVerificationTPA: {
        data: null,
        options: null
      }
      , chartCreditVerificationTPA: {
        data: null,
        options: null
      }
      , chartApprovedTPA: {
        data: null,
        options: null
      }
      , chartToPostTPA: {
        data: null,
        options: null
      }
      , chartContractsTPA: {
        data: null,
        options: null
      }
      , chartFirstPaymentTPA: {
        data: null,
        options: null
      }
      , chartEvidenceTPA: {
        data: null,
        options: null
      }
      , chartSecondPaymentTPA: {
        data: null,
        options: null
      }
      , chartBAInvestorsTPA: {
        data: null,
        options: null
      }
      , chartIdentityTPA: {
        data: null,
        options: null
      }
      , chartFeedBackTPA: {
        data: null,
        options: null
      }

      , response: {}
      , days: 90

      //dashboard
      , originData: []
      , projectsData: []
      , executiveData: []
      , comunicationData: []
      , totals: {
        totalGreen: 0
        , totalYellow: 0
        , totalRed: 0
        , total: 0
        , groups: [
          {
            tGroupGreen: 0
            , tGroupYellow: 0
            , tGroupRed: 0
            , tGroup: 0
          },
          {
            tGroupGreen: 0
            , tGroupYellow: 0
            , tGroupRed: 0
            , tGroup: 0
          },
          {
            tGroupGreen: 0
            , tGroupYellow: 0
            , tGroupRed: 0
            , tGroup: 0
          },
          {
            tGroupGreen: 0
            , tGroupYellow: 0
            , tGroupRed: 0
            , tGroup: 0
          }
        ]
      }
    }
  },
  async mounted() {
    await this.getDashboardInfo();
    let date = new Date();
    this.year = date.getFullYear();
    this.month = date.getMonth() + 1;
    let i = date.getFullYear();
    for (i; i >= 2020; i--) {
      this.years.push(i);
    }
    this.getData(this.month, this.year);
  },
  methods: {
    async getDashboardInfo() {
      try {
        if (this.days != '' && this.days != null && !isNaN(this.days)) {
          this.showLoading(true);
          await axios.get(`/api/v1/opservices/getDashboard?days=${this.days}`)
              .then(response => {
                this.prepareInfo(response.data);
              });
        } else {
          this.errorNotif("Sin días de operación", "Es necesario definir días de operación.")
        }

      } catch (err) {
        this.errorNotif(err.response.data.message, err.response.data.errors);
      }
      this.showLoading(false);
    },

    prepareInfo(data) {

      this.originData = [];
      this.projectsData = [];
      this.executiveData = [];
      this.comunicationData = [];

      data.forEach(element => {
        let green = 0;
        let yellow = 0;
        let red = 0;
        let ops = {};

        let pc = 0;
        let tpa = 0;

        element.body.forEach(item => {
          if (item.TRIAGE == "triage_green") {
            green += item.Total;
          } else if (item.TRIAGE == "triage_yellow") {
            yellow += item.Total;
          } else if (item.TRIAGE == "triage_red") {
            red += item.Total;
          }
        });

        if (element.pc.length != 0 && element.pc != null) {
          element.pc.forEach(i => {
            if (i.TRIAGE == "triage_green") {
              pc = i.PC;
            }
          });
        }

        tpa = element.tpa != "N/A" ? parseFloat(element.tpa[0].TPA).toFixed(2) : element.tpa;

        ops = {
          name: this.getOPServicesName(element.name)
          , green: green
          , yellow: yellow
          , red: red
          , total: green + yellow + red
          , url: this.getOPServicesURL(element.name)
          , pc: parseFloat(pc).toFixed(2)
          , tpa: tpa
        };


        switch (element.type) {
          case 0:
            this.originData.push(ops);
            break;
          case 1:
            this.projectsData.push(ops);
            break;
          case 2:
            this.executiveData.push(ops);
            break;
          case 3:
            this.comunicationData.push(ops);
            break;
        }

      });

      this.generalSummary();
    },

    getOPServicesName(name) {
      let n = "";
      switch (name) {
        case "suppliers_verification":
          n = "Verificación de Proveedores";
          break;
        case "suppliers_technologies_verification":
          n = "Verificación de tecnologías a los Proveedores";
          break;
        case "projects_to_review":
          n = "Revisión de solicitudes de crédito";
          break;
        case "suppliers_ba_verification":
          n = "Verificación de cuentas bancarias de Proveedores";
          break;
        case "projects_to_review_precredit":
          n = "Revisión de pre-solicitud de crédito";
          break;
        case "projects_approved":
          n = "Aprobados";
          break;
        case "projects_to_publish":
          n = "Por publicar";
          break;
        case "projects_to_sign_contracts":
          n = "Para firma de contratos";
          break;
        case "projects_first_payment":
          n = "Para 1er pago a proveedor";
          break;
        case "projects_to_check_evidence":
          n = "Por verificar evidencia";
          break;
        case "projects_second_payment":
          n = "Para 2do pago a proveedor";
          break;
        case "investors_bank_account":
          n = "Verificación de estados de cuenta de Inversionistas";
          break;
        case "investors_identiity":
          n = "Verificación de identidad de Clientes (Inversionistas y Solicitantes)";
          break;
        case "feedback_response":
          n = "Respuesta a retroalimentaciones";
          break;
        case "product_models_verification":
          n = "Verificación de modelos";
          break;
        default:
          // TODO
          break;
      }
      return n;
    },

    getOPServicesURL(name) {
      let n = "";
      switch (name) {
        case "suppliers_verification":
          n = "suppliers/notVerified";
          break;
        case "suppliers_technologies_verification":
          n = "technologies/notVerified";
          break;
        case "projects_to_review":
          n = "projects/revision";
          break;
        case "projects_to_review_precredit":
          n = "projects/revision";
          break;
        case "suppliers_ba_verification":
          n = "bankAccounts/notVerified";
          break;
        case "projects_approved":
          n = "projects/approved";
          break;
        case "projects_to_publish":
          n = "projects/pendingToPublicate";
          break;
        case "projects_to_sign_contracts":
          n = "projects/toSignContracts";
          break;
        case "projects_first_payment":
          n = "treasury/dispersions";
          break;
        case "projects_to_check_evidence":
          n = "projects/toValidateEvidence";
          break;
        case "projects_second_payment":
          n = "treasury/dispersions";
          break;
        case "investors_bank_account":
          n = "clients-control";
          break;
        case "investors_identiity":
          n = "clients-control";
          break;
        case "feedback_response":
          n = "admon/feedback";
          break;
        case "product_models_verification":
          n = "suppliers/products/pending";
          break;
        default:
          // TODO
          break;
      }
      return n;
    },

    generalSummary() {

      this.totals = {
        totalGreen: 0
        , totalYellow: 0
        , totalRed: 0
        , total: 0
        , groups: [
          {
            tGroupGreen: 0
            , tGroupYellow: 0
            , tGroupRed: 0
            , tGroup: 0
          },
          {
            tGroupGreen: 0
            , tGroupYellow: 0
            , tGroupRed: 0
            , tGroup: 0
          },
          {
            tGroupGreen: 0
            , tGroupYellow: 0
            , tGroupRed: 0
            , tGroup: 0
          },
          {
            tGroupGreen: 0
            , tGroupYellow: 0
            , tGroupRed: 0
            , tGroup: 0
          },
        ]
      }

      this.originData.forEach(element => {
        this.totals.groups[0].tGroupGreen += element.green;
        this.totals.groups[0].tGroupYellow += element.yellow;
        this.totals.groups[0].tGroupRed += element.red;
      });

      this.totals.groups[0].tGroup = this.totals.groups[0].tGroupRed + this.totals.groups[0].tGroupYellow + this.totals.groups[0].tGroupGreen;

      this.projectsData.forEach(element => {
        this.totals.groups[1].tGroupGreen += element.green;
        this.totals.groups[1].tGroupYellow += element.yellow;
        this.totals.groups[1].tGroupRed += element.red;
      });

      this.totals.groups[1].tGroup = this.totals.groups[1].tGroupRed + this.totals.groups[1].tGroupYellow + this.totals.groups[1].tGroupGreen;

      this.executiveData.forEach(element => {
        this.totals.groups[2].tGroupGreen += element.green;
        this.totals.groups[2].tGroupYellow += element.yellow;
        this.totals.groups[2].tGroupRed += element.red;
      });

      this.totals.groups[2].tGroup = this.totals.groups[2].tGroupRed + this.totals.groups[2].tGroupYellow + this.totals.groups[2].tGroupGreen;

      this.comunicationData.forEach(element => {
        this.totals.groups[3].tGroupGreen += element.green;
        this.totals.groups[3].tGroupYellow += element.yellow;
        this.totals.groups[3].tGroupRed += element.red;
      });

      this.totals.groups[3].tGroup = this.totals.groups[3].tGroupRed + this.totals.groups[3].tGroupYellow + this.totals.groups[3].tGroupGreen;

      this.totals.totalGreen = this.totals.groups[0].tGroupGreen + this.totals.groups[1].tGroupGreen + this.totals.groups[2].tGroupGreen + this.totals.groups[3].tGroupGreen;
      this.totals.totalYellow = this.totals.groups[0].tGroupYellow + this.totals.groups[1].tGroupYellow + this.totals.groups[2].tGroupYellow + this.totals.groups[3].tGroupYellow;
      this.totals.totalRed = this.totals.groups[0].tGroupRed + this.totals.groups[1].tGroupRed + this.totals.groups[2].tGroupRed + this.totals.groups[3].tGroupRed;
      this.totals.total = this.totals.groups[0].tGroup + this.totals.groups[1].tGroup + this.totals.groups[2].tGroup + this.totals.groups[3].tGroup;
    },

    async handleSelected(url) {
      window.open(url, '_blank');
    },

    async getData(month, year, destroy = false) {
      this.showLoading(true);
      await axios.get(`/api/v1/opservices/getDataByDay?month=${month}&year=${year}`)
          .then(response => {
            this.response = response.data[0];
            this.buildCharts();

          }).catch(error => {

          });
      this.showLoading(false);
    },

    buildCharts() {

      let days = this.response.days;
      let greenTag = "#46c93a";
      let yellowTag = "#ffba00";
      let redTag = "#ff4757";
      let tpaTag = "#184059";
      let pcTag = "#5D8AA6";

      this.chartSuppliersVerification.data = {
        labels: days,
        datasets: [
          {
            data: this.response.suppliers_verification_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.suppliers_verification_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.suppliers_verification_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartSuppliersVerification.options = {
        title: {
          display: true,
          text: 'Verificación de Proveedores'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartTechVerification.data = {
        labels: days,
        datasets: [
          {
            data: this.response.technologies_verification_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.technologies_verification_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.technologies_verification_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartTechVerification.options = {
        title: {
          display: true,
          text: 'Verificación de tecnologías a los Proveedores'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartCreditVerification.data = {
        labels: days,
        datasets: [
          {
            data: this.response.credit_verification_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.credit_verification_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.credit_verification_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartCreditVerification.options = {
        title: {
          display: true,
          text: 'Revisión de solicitudes de crédito'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartApproved.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_approved_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.projects_approved_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.projects_approved_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartApproved.options = {
        title: {
          display: true,
          text: 'Aprobados'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartToPost.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_to_post_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.projects_to_post_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.projects_to_post_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartToPost.options = {
        title: {
          display: true,
          text: 'Por Publicar'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartContracts.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_to_sign_contracts_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.projects_to_sign_contracts_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.projects_to_sign_contracts_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartContracts.options = {
        title: {
          display: true,
          text: 'Por Firmar Contratros'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartFirstPayment.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_first_payment_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.projects_first_payment_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.projects_first_payment_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartFirstPayment.options = {
        title: {
          display: true,
          text: 'Por Primer Pago a Proveedor'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartEvidence.data = {
        labels: days,
        datasets: [
          {
            data: this.response.evidence_verification_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.evidence_verification_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.evidence_verification_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartEvidence.options = {
        title: {
          display: true,
          text: 'Por Verificar Evidencia'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartSecondPayment.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_second_payment_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.projects_second_payment_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.projects_second_payment_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartSecondPayment.options = {
        title: {
          display: true,
          text: 'Por Segundo a Proveedor'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartBAInvestors.data = {
        labels: days,
        datasets: [
          {
            data: this.response.investors_ba_verification_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.investors_ba_verification_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.investors_ba_verification_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartBAInvestors.options = {
        title: {
          display: true,
          text: 'Verificación de estados de cuenta de Inversionistas'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartIdentity.data = {
        labels: days,
        datasets: [
          {
            data: this.response.identity_verification_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.identity_verification_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.identity_verification_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartIdentity.options = {
        title: {
          display: true,
          text: 'Verificación de identidad de Clientes (Inversionistas y Solicitantes)'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartFeedBack.data = {
        labels: days,
        datasets: [
          {
            data: this.response.feedback_response_green,
            label: "",
            borderColor: greenTag,
            fill: false
          },
          {
            data: this.response.feedback_response_yellow,
            label: "",
            borderColor: yellowTag,
            fill: false
          },
          {
            data: this.response.feedback_response_red,
            label: "",
            borderColor: redTag,
            fill: false
          },
        ]
      };
      this.chartFeedBack.options = {
        title: {
          display: true,
          text: 'Comunicación'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };


      this.chartSuppliersVerificationTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.suppliers_verification_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.suppliers_verification_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartSuppliersVerificationTPA.options = {
        title: {
          display: true,
          text: 'Verificación de Proveedores'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartTechVerificationTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.technologies_verification_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.technologies_verification_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartTechVerificationTPA.options = {
        title: {
          display: true,
          text: 'Verificación de tecnologías a los Proveedores'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartCreditVerificationTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.credit_verification_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.credit_verification_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartCreditVerificationTPA.options = {
        title: {
          display: true,
          text: 'Revisión de solicitudes de crédito'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartApprovedTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_approved_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.projects_approved_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartApprovedTPA.options = {
        title: {
          display: true,
          text: 'Aprobados'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartToPostTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_to_post_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.projects_to_post_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartToPostTPA.options = {
        title: {
          display: true,
          text: 'Por Publicar'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartContractsTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_to_sign_contracts_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.projects_to_sign_contracts_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartContractsTPA.options = {
        title: {
          display: true,
          text: 'Por Firmar Contratros'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartFirstPaymentTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_first_payment_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.projects_first_payment_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartFirstPaymentTPA.options = {
        title: {
          display: true,
          text: 'Por Primer Pago a Proveedor'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartEvidenceTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.evidence_verification_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.evidence_verification_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartEvidenceTPA.options = {
        title: {
          display: true,
          text: 'Por Verificar Evidencia'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartSecondPaymentTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.projects_second_payment_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.projects_second_payment_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartSecondPaymentTPA.options = {
        title: {
          display: true,
          text: 'Por Segundo a Proveedor'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartBAInvestorsTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.investors_ba_verification_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.investors_ba_verification_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartBAInvestorsTPA.options = {
        title: {
          display: true,
          text: 'Verificación de estados de cuenta de Inversionistas'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartIdentityTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.identity_verification_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.identity_verification_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartIdentityTPA.options = {
        title: {
          display: true,
          text: 'Verificación de identidad de Clientes (Inversionistas y Solicitantes)'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

      this.chartFeedBackTPA.data = {
        labels: days,
        datasets: [
          {
            data: this.response.feedback_response_tpa,
            label: "Tiempo Promedio de Atención (días)",
            borderColor: tpaTag,
            fill: false
          },
          {
            data: this.response.feedback_response_pc,
            label: "Porcentaje de Cumplimiento (%)",
            borderColor: pcTag,
            fill: false
          },
        ]
      };
      this.chartFeedBackTPA.options = {
        title: {
          display: true,
          text: 'Comunicación'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      };

    },

    handleFilter() {
      if (this.time) {
        this.getData(this.month, this.year, true);
      } else {
        this.getData("", this.year, true);
      }
    }

  }
}
</script>

<style scoped>
.custom-font {
  font-family: 'Poppins', sans-serif !important;
}

.summary-row {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.summary-row-div-col-sm-12 {
  padding: 0;
}

.summary {
  background-color: #ccc;
  border-radius: 5px;
  padding: .5rem 1rem 0.5rem 1rem;
  margin: .5rem;
}

.summary-triage-parent {
  position: relative;
}

.summary-triage {
  position: absolute;
  width: 2rem;
  height: 1.5rem;
  background-color: #ccc;
  border-radius: 5pc;
  text-align: center;
  color: #fff;
  /* left: 3rem; */
}

.summary-item {
  background-color: #fff;
  padding: 1rem !important;
  margin-bottom: 0.5rem;
  border-radius: 10px;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.triage {
  width: 1.5rem;
  height: 1.5rem;
  background-color: #ccc;
  margin-left: -0.5rem;
  border-radius: 5pc;
}

.triage-red {
  background-color: #ff4757 !important;
}

.triage-yellow {
  background-color: #ffba00 !important;
}

.triage-green {
  background-color: #46c93a !important;
}

.align-icons-c {
  text-align: center;
}

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
  padding: 0rem !important;
  text-align: left;
}

.kpis-card {
  background-color: #f2f2f2;
  padding: 1rem;
}
</style>